import { useTemplate, captureExceptionWithNotification } from '@konnektor/scripter-library';
import { RouteName } from 'src/enums/route-name-enum';

export async function TemplateMiddleware ({ to, next, pipeline }) {
  const { template, fetchAndUpdateTemplate } = useTemplate();

  if (template.value === null) {
    try {
      await fetchAndUpdateTemplate(to.params.campaignCode);

      return pipeline();
    } catch (err) {
      captureExceptionWithNotification(err, 'Er is een fout opgetreden bij het ophalen van de template');

      const params = {
        campaignCode: to.params?.campaignCode,
        recordId: to.params?.recordId,
      };

      return next({ name: RouteName.ErrorPage, params });
    }
  }

  return pipeline();
}
